import Exclamation from '../src/Exclamation';
export default Exclamation;
